;(function (angular, _) {
  'use strict'

  class SubcontractorListComponentController {
    constructor (
      // Angular
      $q, $rootScope, $state, $window,
      // Libs
      $uibModal,
      // Managers
      EntityManager,
      // Services
      ColumnService, FilterSidebarService, PreferencesService, SelectionService, UtilService
      // Const
      // Resolved
    ) {
      // DI
      this.entityManager = EntityManager
      this.sidebar = FilterSidebarService
      this.selection = SelectionService.getSelection()
      this.columnService = ColumnService
      this.rootScope = $rootScope
      this.uibModal = $uibModal
      this.preferenceService = PreferencesService
      // Attributes
      this.entities = []
      this.loading = true
      this.columns = []
      this.subs = []
      PreferencesService.getPrefsFor('general').then((prefs) => {
        this.prefs = prefs
        this.columns = ColumnService.getColumns('subcontractor')
        if (prefs.hasOwnProperty('settings')) {
          if (_.get(prefs.settings.entityList, 'pagination')) {
            this.pagination.perPage = _.get(prefs.settings.entityList, 'pagination')
          }
          if (_.get(prefs.settings, 'sideBarVisible')) {
            this.sidebar.filterVisible = _.get(prefs.settings, 'sideBarVisible')
          }
        }
        this.selection.selectedData = []
      })
    }

    $onInit () {
      this.sidebar.init()
      this.columnService.init()

      this.getList().then((data) => {
        this.entities = data
      })
      this.rootScope.$on('new-subcontractor', () => {
        this.getList()
      })
    }

    getList () {
      this.loading = true
      const query = this.entityManager.query({ conditions: { __t: 'EntitySubcontractor' } })
        .fields('type __t _id address defaultAddress label insensitive number')
        .paginate(this.pagination.toQueryOptions())
      if (_.get(this, 'pagination.search')) {
        if (_.get(this, 'pagination.search.subcontractors')) {
          query.select(_.get(this, 'pagination.search.subcontractors._id'), '_id')
        }
      }
      return this.entityManager.get(query).then(({ data, meta }) => {
        this.pagination.totalElements = meta.total
        this.entities = data
        this.loading = false
        return this.entities
      })
    }

    clearSearch () {
      if (_.isEmpty(this.pagination.search)) {
        return
      }
      this.pagination.search = {}
      return this.getList()
    }

    sort (name) {
      this.reverse = this.pagination.orderBy === name ? !this.reverse : false
      this.pagination.orderBy = name
      this.pagination.reverse = this.reverse
      return this.getList()
    }

    dropColumn (source, target) {
      var newIndex = _.findIndex(this.columns, { id: target })
      var oldIndex = _.findIndex(this.columns, { id: source })
      this.columns.splice(newIndex, 0, this.columns.splice(oldIndex, 1)[0])
      this.prefs.save().then(function () {
        this.columns = this.columnService.getColumns('subcontractor')
      })
    }

    saveColumns () {
      this.prefs.settings.entityList.columns = this.columns
      this.prefs.save().then((data) => {
        this.columns = this.columnService.getColumns('entity')
      })
    }

    resetColumns () {
      this.prefs.settings.entityList.columns = this.columnService.buildColumns([], this.columnService.getDefaultColumns('entity'))
      this.prefs.save().then(function (data) {
        this.columns = this.columnService.getColumns('entity')
      })
    }

    getSubcontractors (search = '') {
      const query = this.entityManager.query({
        conditions: {
          $and: [
            {
              $or: [
                {
                  'insensitive': {
                    $regex: search,
                    $options: 'i'
                  }
                },
                {
                  'number': {
                    $regex: search,
                    $options: 'i'
                  }
                }
              ]
            },
            {
              __t: 'EntitySubcontractor'
            }
          ]
        }
      })
        .fields('_id label number')
        .limit(10)
      return this.entityManager.get(query).then(({ data }) => {
        this.subs = data
      })
    }

    editSubcontractor (sub, index) {
      return this.uibModal.open({
        controller: 'EditSubcontractorModalController',
        templateUrl: '/app/modules/subcontractor/modals/edit-subcontractor/edit-subcontractor-modal.template.html',
        controllerAs: '$ctrl',
        resolve: {
          subcontractor: [() => {return angular.copy(sub)}]
        }
      }).result.then((res) => {
        return res.save().then(() => {
          this.entities[index] = res
        })
      })
    }
  }

  SubcontractorListComponentController.$inject = [
    // Angular
    '$q', '$rootScope', '$state', '$window',
    // Libs
    '$uibModal',
    // Managers
    'EntityManager',
    // Services
    'ColumnService', 'FilterSidebarService', 'PreferencesService', 'SelectionService', 'UtilService'
    // Const
    // Resolved
  ]

  angular.module('kilo.routes.subcontractor.list')
    .component('subcontractorList', {
      bindings: {
        pagination: '<'
      },
      templateUrl: '/app/modules/subcontractor/list/components/subcontractor-list/subcontractor-list.template.html',
      controller: SubcontractorListComponentController
    })
})(window.angular, window._)
